/// <amd-module name="Analytics/Boards/BoardsQueries/BacklogsQuery" />
import { AnalyticsCacheableQueryBase, CommonFeatureCommandName } from "Analytics/Common/AnalyticsCacheableQueryBase";
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";

/** Describes a WIT backlog */
export interface Backlog {
    /** The name of the board */
    BoardName: string;
    /** The level of the board (highest board level refers to the lowest-level backlog) */
    BoardLevel: number;
    /** The backlog level name the column is associated with. */
    BoardCategoryReferenceName: string;
    /** The visibility of the board */
    IsBoardVisible: boolean;
}

/**
 * Retrieves the current backlogs that are visible for any of the given teams in the given project.
 * Ordered by backlog level in descending order.
 * @param project ID or name of a project.
 * @param teamId ID of a team within the given project.
 */
export class BacklogsQuery extends AnalyticsCacheableQueryBase<Backlog[]> {
    private static generateQueryOptions(project: string, teamIds: string[]): ODataQueryOptions {
        if (!teamIds || teamIds.length == 0) {
            throw new Error("No team Id's were supplied to Backlogs query.");
        }

        let teamsQuery = "";
        for (let i = 0; i < teamIds.length; i++) {
            if (i > 0) {
                teamsQuery += " or ";
            }
            teamsQuery += `TeamSK eq ${teamIds[i]}`;
        }

        return {
            project: project,
            entityType: "BoardLocations",
            oDataVersion: latestODataVersion,
            $apply: `filter(${teamsQuery})/groupby((BoardName,BoardLevel,BoardCategoryReferenceName,IsBoardVisible))`,
            $orderby: "BoardLevel desc"
        };
    }

    constructor(project: string, teamIds: string[]) {
        super(CommonFeatureCommandName, BacklogsQuery.generateQueryOptions(project, teamIds));
    }

    public getQueryName(): string {
        return "BacklogQuery";
    }
}
